import { Account } from '@ally/data-types-afg-accounts'
import { WealthTableData } from './TableColumns'

export function getWealthTableData(accounts: Account[]): WealthTableData[] {
  const hasMultipleAccounts = accounts.length > 1
  const summarizedValue = accounts.reduce(
    (accum, account) => accum + (account.value?.total ?? 0),
    0,
  )

  return [
    {
      accounts,
      totalValue: hasMultipleAccounts
        ? summarizedValue
        : accounts[0].value?.total ?? 0,
      netReturn: hasMultipleAccounts
        ? null
        : accounts[0].value?.netReturnPercent ?? 0,
      netYield: hasMultipleAccounts
        ? null
        : accounts[0].value?.yieldPercent ?? 0,
    },
  ]
}

/**
 * Sorts wealth accounts based on accountNumber ensuring
 * consistent account order
 * TODO: Update to sort by account date once that property is available
 */
export const sortWealthAccountsGroup = (accounts: Account[]): Account[] => {
  return accounts.sort((accountA, accountB) => {
    return accountA.accountNumber.localeCompare(accountB.accountNumber)
  })
}
